import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Spinner, Table } from 'react-bootstrap';
import { api } from "../../services/api";
import Swal from "sweetalert2";
import { FaEdit, FaPlus, FaArrowLeft } from "react-icons/fa";

export default function ModalConcTaxa({ show, onHide }) {
    const [loading, setLoading] = useState(false);
    const [loadingEdicao, setLoadingEdicao] = useState(false);
    const [view, setView] = useState('lista'); 
    const [taxasCadastradas, setTaxasCadastradas] = useState([]);
    const [lookups, setLookups] = useState({ roteamentos: [], bandeiras: [], condicoes: [] });
    
    const [form, setForm] = useState({
        roteamento: '',
        bandeira: '',
        condicao: '',
        taxa: 0,
        codicadastro: ''
    });

    useEffect(() => {
        if (show) {
            listarTaxas();
            api.get('/financeiro/conciliacao/roteamentos')
                .then(res => setLookups(prev => ({ ...prev, roteamentos: res.data })))
                .catch(err => console.error("Erro ao carregar roteamentos", err));
            setView('lista');
        }
    }, [show]);

    const listarTaxas = async () => {
        setLoading(true);
        try {
            const res = await api.get('/financeiro/conciliacao/config-taxas');
            setTaxasCadastradas(res.data || []);
        } catch (err) {
            console.error("Erro ao listar taxas", err);
        } finally {
            setLoading(false);
        }
    };

    const handleRoteamento = async (val) => {
        setForm({ roteamento: val, bandeira: '', condicao: '', taxa: 0, codicadastro: '' });
        if (!val) return;
        try {
            const res = await api.get(`/financeiro/conciliacao/bandeiras?roteamento=${val}`);
            setLookups(prev => ({ ...prev, bandeiras: res.data, condicoes: [] }));
        } catch (err) {
            Swal.fire("Erro", "Erro ao buscar bandeiras", "error");
        }
    };

    const handleBandeira = async (val) => {
        setForm(prev => ({ ...prev, bandeira: val, condicao: '', taxa: 0 }));
        if (!val) return;
        try {
            const res = await api.get(`/financeiro/conciliacao/condicoes?roteamento=${form.roteamento}&bandeira=${val}`);
            setLookups(prev => ({ ...prev, condicoes: res.data }));
        } catch (err) {
            console.error(err);
        }
    };

    const renderOptions = (lista, campo) => {
        return lista.map((item, index) => {
            const valor = typeof item === 'object' ? item[campo] : item;
            return <option key={index} value={valor}>{valor}</option>;
        });
    };

    const handleEditar = async (item) => {
        setLoadingEdicao(true);
        setView('formulario');
        try {
            const resB = await api.get(`/financeiro/conciliacao/bandeiras?roteamento=${item.roteamento}`);
            const resC = await api.get(`/financeiro/conciliacao/condicoes?roteamento=${item.roteamento}&bandeira=${item.bandeira}`);
            
            setLookups(prev => ({ 
                ...prev, 
                bandeiras: resB.data, 
                condicoes: resC.data 
            }));
            
            setForm({
                roteamento: item.roteamento,
                bandeira: item.bandeira,
                condicao: item.condicao,
                taxa: item.taxa,
                codicadastro: item.codicadastro
            });

        } catch (err) {
            Swal.fire("Erro", "Falha ao carregar dados", "error");
        } finally {
            setLoadingEdicao(false);
        }
    };

    const handleSalvar = async () => {
        setLoading(true);
        try {
            await api.post('/financeiro/conciliacao/taxa', form);
            Swal.fire("Sucesso", "Configuração salva!", "success");
            listarTaxas();
            setView('lista');
        } catch (err) {
            Swal.fire("Erro", "Erro ao salvar", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal 
            show={show} 
            onHide={onHide} 
            centered 
            size="lg" 
            backdrop="static"
            scrollable={true} // Isso garante que o scroll fique dentro do corpo do modal
        >
            <Modal.Header closeButton className="bg-dark text-white p-2">
                <Modal.Title className="small fw-bold ms-2">
                    {view === 'lista' ? 'TAXAS CADASTRADAS' : 'EDITAR TAXA'}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="bg-light" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                {view === 'lista' ? (
                    <>
                        <div className="d-flex justify-content-between mb-3 align-items-center">
                            <h6 className="fw-bold m-0">Configurações Ativas</h6>
                            <Button variant="success" size="sm" onClick={() => { 
                                setForm({roteamento:'', bandeira:'', condicao:'', taxa:0, codicadastro:''}); 
                                setView('formulario'); 
                            }}>
                                <FaPlus className="me-2" /> NOVA TAXA
                            </Button>
                        </div>
                        
                        <div className="table-responsive">
                            <Table striped bordered hover size="sm" className="bg-white shadow-sm mb-0">
                                <thead className="table-secondary small text-center sticky-top">
                                    <tr>
                                        <th>Roteamento</th>
                                        <th>Bandeira</th>
                                        <th>Condição</th>
                                        <th>Taxa</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody className="small text-center">
                                    {taxasCadastradas.map((t, i) => (
                                        <tr key={i}>
                                            <td>{t.roteamento}</td>
                                            <td>{t.bandeira}</td>
                                            <td>{t.condicao}</td>
                                            <td className="fw-bold text-danger">{Number(t.taxa).toFixed(2)}%</td>
                                            <td>
                                                <Button variant="outline-primary" size="sm" onClick={() => handleEditar(t)}>
                                                    <FaEdit />
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </>
                ) : (
                    <Form>
                        <Button variant="link" size="sm" onClick={() => setView('lista')} className="mb-3 p-0 text-decoration-none fw-bold">
                            <FaArrowLeft className="me-2" /> VOLTAR
                        </Button>

                        {loadingEdicao ? (
                            <div className="text-center p-5"><Spinner animation="border" /></div>
                        ) : (
                            <Row className="g-3">
                                <Col md={12}>
                                    <label className="small fw-bold">Roteamento</label>
                                    <select className="form-select form-select-sm" 
                                        value={form.roteamento} 
                                        onChange={e => handleRoteamento(e.target.value)}>
                                        <option value="">Selecione...</option>
                                        {renderOptions(lookups.roteamentos, 'ROTEAMENTO')}
                                    </select>
                                </Col>
                                <Col md={12}>
                                    <label className="small fw-bold">Bandeira</label>
                                    <select className="form-select form-select-sm" 
                                        value={form.bandeira} 
                                        onChange={e => handleBandeira(e.target.value)}
                                        disabled={!form.roteamento}>
                                        <option value="">Selecione...</option>
                                        {renderOptions(lookups.bandeiras, 'BANDEIRA')}
                                    </select>
                                </Col>
                                <Col md={12}>
                                    <label className="small fw-bold">Condição</label>
                                    <select className="form-select form-select-sm" 
                                        value={form.condicao} 
                                        onChange={e => setForm({...form, condicao: e.target.value})}
                                        disabled={!form.bandeira}>
                                        <option value="">Selecione...</option>
                                        {renderOptions(lookups.condicoes, 'CONDICAO')}
                                    </select>
                                </Col>
                                <Col md={6}>
                                    <label className="small fw-bold">Taxa (%)</label>
                                    <Form.Control size="sm" type="number" value={form.taxa} onChange={e => setForm({...form, taxa: e.target.value})} />
                                </Col>
                                <Col md={6}>
                                    <label className="small fw-bold">Cód. Cadastro</label>
                                    <Form.Control size="sm" type="text" value={form.codicadastro} onChange={e => setForm({...form, codicadastro: e.target.value})} />
                                </Col>
                            </Row>
                        )}
                    </Form>
                )}
            </Modal.Body>

            <Modal.Footer className="p-2">
                <Button variant="secondary" size="sm" onClick={onHide}>FECHAR</Button>
                {view === 'formulario' && !loadingEdicao && (
                    <Button variant="primary" size="sm" onClick={handleSalvar} disabled={loading}>
                        {loading ? 'SALVANDO...' : 'GRAVAR'}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
}